// Vendor Libs
import React from 'react';

// Components
import Error from '../core/error';
import Loading from '../core/loading';
import NetworkForm from './network-form';
import Permissions from '../core/permissions';

// Containers
import FormData from '../../containers/form-data';

const formName = 'editNetwork';

function EditNetwork() {
    return (
        <Permissions
            accessRequirement="update"
            elementService="network"
            notAuthorizedMessage={true}
            requiresServiceAccess={true}
        >
            <FormData formName={formName}>
                {({ resetForm, searchFetching, searchValues: { networkId } }) => (
                    <>
                        {networkId ? (
                            <NetworkForm
                                {...{
                                    className: 'edit-network',
                              editing: true,
                              formName,
                                    onReset: (submitted, resetValues) => resetForm(submitted, resetValues, true),
                                }}
                            />
                        ) : (
                            <Error className="edit-network--message" error="Select a network from the list." />
                        )}
                        <Loading loading={searchFetching} />
                    </>
                )}
            </FormData>
        </Permissions>
    );
}

export default EditNetwork;
